<template>
  <f7-page
    name="circonia"
    :infinite-distance="50"
    :infinite-preloader="false"
    infinite
    @page:beforeout="onPageClose"
    :hide-bars-on-scroll="false"
  >
    <f7-navbar
      :sliding="false"
      innerClass="navbar-separator"
    >
      <!-- <f7-link class="text-white" icon-ios="f7:menu" icon-md="material:menu" panel-open="left"></f7-link> -->
      <f7-nav-title class="text-madai">Circonia</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-md="material:search" href="/buscar/" @click="activarBusqueda = false"></f7-link>
      </f7-nav-right>

      <busqueda
        :activarBusqueda="activarBusqueda"
        :id="'busqueda'"
        :catalogo="catalogo"
        :filtros="filtros"
        @searchbar:disable="activarBusqueda = false"
        @search:load-complete="resp => catalogoPaginador = resp"
        @search:data="resp => catalogoFiltrado = resp"
      ></busqueda>
    </f7-navbar>

    <f7-toolbar tabbar scrollable position="top" class="h-60">
      <f7-link class="text-filter-blue bold">
        Filtros
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'precio' }"
        @click="filtro = 'precio'"
        :tab-link-active="filtro === 'precio'"
      >
        <img src="assets/img/filtros/precio-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[0].minValue === Math.trunc(priceMin) && filtros[0].maxValue === Math.trunc(priceMax) ? 'precio' : 'filtrado' }}
        </div>
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'estilo' }"
        @click="filtro = 'estilo'"
        :tab-link-active="filtro === 'estilo'"
      >
        <img src="assets/img/filtros/estilo.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[2].name === '*' ? 'Estilo' : filtros[2].name }}
        </div>
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'material' }"
        @click="filtro = 'material'"
        :tab-link-active="filtro === 'material'"
      >
        <img src="assets/img/filtros/material-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[4].value === '*' ? 'Material' : filtros[4].value }}
        </div>
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'color' }"
        @click="filtro = 'color'"
        :tab-link-active="filtro === 'color'">
        <img src="assets/img/filtros/color-on.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[1].value === '*' ? 'Color' : filtros[1].value }}
        </div>
      </f7-link>
      <f7-link
        :class="{ 'filter-tabbar-selected': filtro === 'genero' }"
        @click="filtro = 'genero'"
        :tab-link-active="filtro === 'genero'"
      >
        <img src="assets/img/filtros/genero.svg" alt="" srcset="" width="36">
        <div class="fs-10 text-black bold">
          {{ filtros[3].value === '*' ? 'Género' : filtros[3].value }}
        </div>
      </f7-link>
      <f7-link
        class="text-filter-blue bold"
        @click="limpiarFiltros()"
      >
        Reiniciar
      </f7-link>
    </f7-toolbar>

    <f7-list v-if="catalogoPaginador.length === 0">
      <f7-list-item>No se encontraron resultados</f7-list-item>
    </f7-list>

    <template v-else>
      <f7-list class="f7-list-item-no-border m-t-10 m-b-0">
        <f7-list-item
          v-for="(itm, idx) in catalogoPaginador"
          :key="idx"
          :link="`/zirconia/${itm.ida_zirconia}/`"
        >
          <list-zirconia :itm="itm"></list-zirconia>
        </f7-list-item>
      </f7-list>

      <template v-if="catalogo.length > catalogoPaginador.length && catalogoPaginador.length < catalogoFiltrado.length">
        <div class="text-center m-t-20 p-l-15 p-r-15">
          <f7-button @click="$evento.emit('search:load')" large raised fill>Cargar más</f7-button>
        </div>
      </template>

      <!-- Banner envío -->
      <f7-block class="text-center">
        <img class="wd-100" src="assets/img/banners/msi.jpg" alt="">
        <img class="wd-100" src="assets/img/banners/envio_asegurado.jpg" alt="">
        <img class="m-t-40 m-b-20" src="assets/img/otros/ssl-secure.jpg" alt="" style="border-radius: 10px;" height="50">
      </f7-block>
    </template>

    <f7-sheet class="h-210 sheet-border-radius-15" :opened="filtro === 'estilo'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Estilo</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="m-t-15 p-5 p-l-15 p-r-15">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[2].name === 'compromiso' }"
            @click="filtros[2].name === 'compromiso' ? filtros[2].name = '*' : filtros[2].name = 'compromiso'"
          >
            <img src="assets/img/filtros/compromiso.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Compromiso</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[2].name === 'churumbela' }"
            @click="filtros[2].name === 'churumbela' ? filtros[2].name = '*' : filtros[2].name = 'churumbela'"
          >
            <img src="assets/img/filtros/churumbela.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Churumbela</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[2].name === 'promesa' }"
            @click="filtros[2].name === 'promesa' ? filtros[2].name = '*' : filtros[2].name = 'promesa'"
          >
            <img src="assets/img/filtros/promesa.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Promesa</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[2].name === 'fancy' }"
            @click="filtros[2].name === 'fancy' ? filtros[2].name = '*' : filtros[2].name = 'fancy'"
          >
            <img src="assets/img/filtros/fancy.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Fancy</span>
          </f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-210 sheet-border-radius-15" :opened="filtro === 'genero'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Género</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="m-t-15 p-5 p-l-15 p-r-15">
          <f7-col
            class="p-7 text-center"
            :class="{ 'filter-selected': filtros[3].value === 'dama' }"
            @click="filtros[3].value === 'dama' ? filtros[3].value = '*' : filtros[3].value = 'dama'"
          >
            <img src="assets/img/filtros/dama.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Dama</span>
          </f7-col>
          <f7-col
            class="p-7 text-center"
            :class="{ 'filter-selected': filtros[3].value === 'caballero' }"
            @click="filtros[3].value === 'caballero' ? filtros[3].value = '*' : filtros[3].value = 'caballero'"
          >
            <img src="assets/img/filtros/caballero.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Caballero</span>
          </f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-210 sheet-border-radius-15" :opened="filtro === 'color'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Color</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-row class="m-t-15 p-5 p-l-15 p-r-15">
          <f7-col
            class="p-7 text-center"
            :class="{ 'filter-selected': filtros[1].value === 'amarillo' }"
            @click="filtros[1].value === 'amarillo' ? filtros[1].value = '*' : filtros[1].value = 'amarillo'"
          >
            <img src="assets/img/color/oro_amarillo.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Oro Amarillo</span>
          </f7-col>
          <f7-col
            class="p-7 text-center"
            :class="{ 'filter-selected': filtros[1].value === 'blanco' }"
            @click="filtros[1].value === 'blanco' ? filtros[1].value = '*' : filtros[1].value = 'blanco'"
          >
            <img src="assets/img/color/oro_blanco.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Oro Blanco</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[1].value === 'rosa' }"
            @click="filtros[1].value === 'rosa' ? filtros[1].value = '*' : filtros[1].value = 'rosa'"
          >
            <img src="assets/img/color/oro_rosa.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Oro Rosa</span>
          </f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-250 sheet-border-radius-15" :opened="filtro === 'precio'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Precio</span>
        </div>
      </f7-toolbar>
      <f7-page-content>
        <f7-list simple-list class="m-0 m-t-20 f7-list-item-no-border p-l-25 p-r-25">
          <f7-list-item>
            <f7-list-item-cell class="width-auto flex-shrink-0 m-0">
              <!-- <f7-icon ios="f7:money_dollar_round" md="material:attach_money"></f7-icon>-->
            </f7-list-item-cell>
            <f7-list-item-cell class="flex-shrink-3">
              <f7-range
                ref="precio"
                :min="priceMin"
                :max="priceMax"
                :step="1"
                :value="[filtros[0].minValue, filtros[0].maxValue]"
                :label="true"
                :dual="true"
                @range:change="onChange"
              ></f7-range>
            </f7-list-item-cell>
            <f7-list-item-cell class="width-auto flex-shrink-0">
              <!-- <f7-icon ios="f7:money_dollar_round_fill" md="material:monetization_on"></f7-icon>-->
            </f7-list-item-cell>
          </f7-list-item>
        </f7-list>
        <f7-row>
          <f7-col></f7-col>
          <f7-col>
            <f7-list no-hairlines-md class="m-t-5">
              <f7-list-input
                label="Mínimo"
                type="number"
                placeholder="Mínimo"
                :value="filtros[0].minValue"
                @input="filtros[0].minValue = Number($event.target.value)"
              ></f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col>
            <f7-list no-hairlines-md class="m-t-5">
              <f7-list-input
                label="Máximo"
                type="number"
                placeholder="Máximo"
                :value="filtros[0].maxValue"
                @input="filtros[0].maxValue = Number($event.target.value)"
              ></f7-list-input>
            </f7-list>
          </f7-col>
          <f7-col></f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>

    <f7-sheet class="h-220 sheet-border-radius-15" :opened="filtro === 'material'" @sheet:closed="filtro = ''">
      <f7-toolbar class="bg-madai">
        <div class="left p-l-20">
          <span class="bold fs-16 text-white">Filtrar por Material</span>
        </div>
      </f7-toolbar>
      <f7-page-content class="p-10 p-t-20">
        <f7-row class="m-b-20">
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[4].value === '14K' }"
            @click="filtros[4].value === '14K' ? filtros[4].value = '*' : filtros[4].value = '14K'"
          >
            <img src="assets/img/material/kilates_14.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">14 kilates</span>
          </f7-col>
          <f7-col
            class="text-center p-7"
            :class="{ 'filter-selected': filtros[4].value === '0.925' }"
            @click="filtros[4].value === '0.925' ? filtros[4].value = '*' : filtros[4].value = '0.925'"
          >
            <img src="assets/img/material/plata.svg" width="48"/>
            <span class="d-block fs-10 bold text-uppercase">Plata</span>
          </f7-col>
        </f7-row>
      </f7-page-content>
    </f7-sheet>
  </f7-page>
</template>

<script>
import busqueda from '@/components/busqueda'
import listZirconia from '@/components/list-zirconia.vue'

export default {
  components: {
    busqueda,
    listZirconia
  },
  data () {
    return {
      cargando: true,
      activarBusqueda: false,
      catalogo: [],
      catalogoFiltrado: [],
      catalogoPaginador: [],
      filtros: [
        {
          prop: 'price',
          minValue: 0,
          maxValue: 0
        },
        {
          prop: 'color',
          value: '*'
        },
        {
          prop: 'estilo',
          name: '*'
        },
        {
          prop: 'gender',
          value: '*'
        },
        {
          prop: 'specification',
          value: '*'
        }
      ],
      filtro: '',
      priceMin: 0,
      priceMax: 0
    }
  },
  methods: {
    async init () {
      try {
        this.cargando = true
        this.$f7.dialog.preloader('Descargando catálogo...')
        this.catalogo = await this.$api.catalogo.zirconia()
        // TODO: limpiar DB y eliminar elementos con valor NULL
        this.catalogo = this.catalogo.filter(item => item.name !== null)
        // Buscar precios mínimos y máximos
        this.catalogo.forEach((item, idx) => {
          if (idx === 0) {
            this.priceMin = item.price
            this.priceMax = item.price
          }
          if (Math.floor(this.priceMin) !== 0) {
            this.priceMin = item.price < this.priceMin ? item.price : this.priceMin
          }
          this.priceMax = item.price > this.priceMax ? item.price : this.priceMax
        })
        // Asignar precios mínimos y máximos a filtros y range
        this.filtros[0].minValue = this.$refs.precio.f7Range.min = Math.floor(this.priceMin)
        this.filtros[0].maxValue = this.$refs.precio.f7Range.max = Math.ceil(this.priceMax)

        // if (this.$f7.router.context && this.$f7.router.context.decorativa) {
        //   let decorativa = this.$f7.router.context.decorativa
        //   if (decorativa === '3 piedras') { this.filtros[5].value = decorativa }
        //   if (decorativa === 'chanel') { this.filtros[2].value = decorativa }
        //   if (decorativa === 'halo') { this.filtros[5].value = decorativa }
        //   if (decorativa === 'pave') { this.filtros[2].value = decorativa }
        //   if (decorativa === 'laterales') { this.filtros[6].value = 'N/A' }
        //   if (decorativa === 'solitario') { this.filtros[7].value = 'N/A' }
        // }
        this.cargando = false
        this.$f7.dialog.close()
      } catch (err) {
        this.catalogo = []
        this.cargando = false
        this.$f7.dialog.close()
      }
    },
    limpiarFiltros () {
      this.filtros.forEach((itm, idx) => {
        if (this.filtros[idx].value) { this.filtros[idx].value = '*' }
        if (this.filtros[idx].name) { this.filtros[idx].name = '*' }
      })
      this.$refs.precio.setValue([this.priceMin, this.priceMax])
    },
    actualizarElemento (item) {
      this.$set(this.catalogo, this.catalogo.findIndex(itm => itm.cve === item.cve), item)
      this.$set(this.catalogoFiltrado, this.catalogoFiltrado.findIndex(itm => itm.cve === item.cve), item)
      this.$set(this.catalogoPaginador, this.catalogoPaginador.findIndex(itm => itm.cve === item.cve), item)
    },
    onChange (values) {
      clearTimeout(this.delayBusqueda)

      this.delayBusqueda = setTimeout(() => {
        this.$set(this.filtros, 0, { minValue: values[0], maxValue: values[1], prop: 'price' })
      }, 250)
    },
    onPageClose () {
      this.$evento.off('update-content')
    }
  },
  created () {
    this.init()
    this.$evento.on('update-content', this.actualizarElemento)
  }
}
</script>

<style scoped>
.thumb {
  height: 150px;
}

.input-with-value {
  text-align: center !important;
}
</style>
